export default __webpack_public_path__ + "static/media/mintd-loader.2d08980b.gif";